
import React from 'react';
import { useNavigate } from 'react-router-dom';
import NodeEditor from '@/components/content/NodeEditor';
import { useRoleAccess } from '@/hooks/useRoleAccess';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const CreateContent: React.FC = () => {
  const navigate = useNavigate();
  const { canCreateContent } = useRoleAccess();

  if (!canCreateContent) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Access Restricted</h1>
          <p className="text-black mb-4">
            You need contributor access or higher to create content.
          </p>
          <Button onClick={() => navigate(-1)}>Go Back</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-4"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
        <h1 className="text-3xl font-bold">Create New Content</h1>
        <p className="text-black mt-1">
          Share your knowledge and contribute to the Academy
        </p>
      </div>

      <NodeEditor
        onSave={(node) => navigate(`/content/view/${node.id}`)}
        onCancel={() => navigate(-1)}
      />
    </div>
  );
};

export default CreateContent;
